<script lang="ts">
import FicheSalarie from '@/generated/fiches/FicheSalarie.vue';
import { storeAdresse, storeRib } from '@/generated/stores';
import Adresse from '@/extend/classes/Adresse';
import Salarie from '@/extend/classes/Salarie';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import Rib from '@/extend/classes/Rib';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheSalarie,
  computed: {
    selectedAdresse(): Adresse {
      let adresse = new Adresse();
      if (this.salarie.adresseId == 0) {
        adresse = storeAdresse.createNewAdresse();
      } else {
        adresse = storeAdresse.getAdresse(this.salarie.adresseId);
      }
      adresse.canUpdate = this.salarie.canUpdate;
      adresse.owner = new Owner();
      adresse.owner.objType = ObjTypes.CONTACT;
      adresse.owner.objId = this.salarie.id;

      return adresse;
    },
    selectedRib(): Rib {
      let rib = new Rib();
      if (this.salarie.ribId == 0) {
        rib = storeRib.createNewRib();
      } else {
        rib = storeRib.getRib(this.salarie.ribId);
      }
      const owner = new Owner();
      owner.objType = ObjTypes.SALARIE;
      owner.objId = this.salarie.id;
      rib.owner = owner;
      return rib;
    }
  },
  methods: {
    isDisplayed(value: string): boolean {      
       if (value == 'SALARIE_AVATAR') {
          return !this.isSalarie && this.salarie.id > 0;
        }
      return value == 'SALARIE' || this.salarie.id > 0;
    },
    salarieUpdated(salarie: Salarie) {
      salarie.fromSalarie(salarie);
    },
    adresseUpdated(adresse: Adresse) {
      adresse.owner = new Owner()
      adresse.owner.objType = ObjTypes.CONTACT;
      adresse.owner.objId = this.salarie.id;
    }
  }
})

</script>
